/** Height of the sticky topbar. Sticky page furniture (tabs) offsets by this,
 *  so the value lives here rather than in either consumer. */
export const TOPBAR_HEIGHT = 56;

/** Horizontal gutter on the shell's main column. */
export const CONTENT_GUTTER = { xs: 2, md: 3 };

/** Shared timing for the discovery sidebar's expand/collapse animations, so the
 *  grid-column ease, the overlay slide, and the compact↔full crossfade all move
 *  together. `_MS` is the numeric form MUI transition components expect. */
export const SIDEBAR_TRANSITION_MS = 250;
export const SIDEBAR_TRANSITION = `${SIDEBAR_TRANSITION_MS}ms ease`;

/** `CONTENT_GUTTER` negated, for children that bleed past it to the viewport
 *  edge. Derived so it cannot drift from the gutter it cancels. */
export const CONTENT_GUTTER_BLEED = Object.fromEntries(
  Object.entries(CONTENT_GUTTER).map(([breakpoint, value]) => [breakpoint, -value]),
);
